module.exports = __webpack_public_path__ + "img/lock2.a0417c2e.svg";